import { render, staticRenderFns } from "./TeamPickerButton.vue?vue&type=template&id=2a840a50&scoped=true"
import script from "./TeamPickerButton.vue?vue&type=script&lang=js"
export * from "./TeamPickerButton.vue?vue&type=script&lang=js"
import style0 from "./TeamPickerButton.vue?vue&type=style&index=0&id=2a840a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a840a50",
  null
  
)

export default component.exports